var constants = {
  COOKIES: {
    AGJSSESSIONID: "agjssessionid",
    VERIFICAR_AVISOS: "VERIFICAR_AVISOS",
    RH_IS_ADMIN_CONDOMINIOS: "rhIsAdminCondominios",
  },
  DYNAMIC_DATA: {
    EMISSOR: {},
    PRODUCTS: [],
    CAMPANHAS: [],
    OPERATING_DAYS: [],
    TYPE_OF_ESTABLISHMENT: [],
    VIDEO_URL: [],
    TIPO_LOGRADOURO: [],
    SEXO: [],
  },
  EVENTS: {
    CARD_CONFIRMATION: "Card.confirmation",
    CARD_SELECTED: "Card.selected",
    ESTABLISHMENT_SELECTED: "Establishment.selected",
    HTTP_ERROR: "Http.error",
    NAVIGATION_SET_PRODUCTS: "Navigation.setProducts",
    NAVIGATION_SET_VIEW: "Navigation.setView",
    NAVIGATION_SET_VIEW_PRODUCT: "Navigation.setViewProduct",
    NAVIGATION_CHECK_CARD: "Navigation.checkCard",
    BANK_AND_QUALIF_DATA_CHECK: "BankAndQualifData.check",
    ESTABLISHMENT_DATA_LOADED: "Establishment.dataLoaded",
    REQUEST_FORM_BANK_DATA_AND_QUALIF: "requestForm.BankDataAndQualific",
    SEND_FORM_BANK_DATA_AND_QUALIF: "sendForm.BankDataAndQualific",
    ACCREDITATION_DATA_BANK_LOADED: "AccreditationBank.dataLoaded",
    ACCREDITATION_DATA_QUALIFIC_LOADED: "AccreditationQualific.dataLoaded",
    TUTORIAL_ENABLE: "Tutorial.Enable",
    TUTORIAL_START: "Tutorial.start",
    SHOW_VIDEO: "show.Video",
    TUTORIAL_PREFERENCE: "Tutorial.preference",
    ESTABLISHMENT_ACTIVATED: "Establishment.activated",
    ESTABLISHMENT_UPDATED: "Establishment.updated",
    SHOW_LOADER: "show.Loader",
    HIDE_LOADER: "hide.Loader",
    PREVENT_LOADER: "prevent.Loader",
    RH_SELECTED: "RH.selected",
    RH_UPDATED: "RH.updated",
    SHOW_DESLIGAMENTO: "Desligamento.show",
    MEUS_PEDIDOS_SEND_TO_PEDIDO_ONLINE: "meuspedidos.send.to.pedidoonline",
    PEDIDO_ONLINE_ACOMPANHAR_PEDIDO: "pedidoonline.acompanhar.pedido",
    OPEN_MODAL_SELECT_COMPANY: "open.modal.select_company",
  },
  MEDIA_QUERIES: {
    MOBILE_SCREEN: "(max-width: 768px)",
    TABLET_SCREEN: "(max-width: 992px)",
    DESKTOP_SCREEN: "(min-width: 992px)",
  },
  SESSION: {
    PRODUCT_CARD_SET: "ProductCard.set",
    ESTABLISHMENT_ACTIVATED: "Establishment.activated",
    RH_ACTIVATED: "RH.activated",
    ESTABLISHMENT_REFUND_PRINT: "Establishment.RefundPrint",
    ESTABLISHMENT_REFUND_GUIDE_PRINT: "Establishment.RefundGuidePrint",
    ESTABLISHMENT_SALES_PRINT: "Establishment.SalesSearchDataPrint",
    BENEFICIARIO_EXTRACT_CARDNUMBER_PRINT:
      "Beneficiario.ExtractCardNumberPrint",
    CONTINUAR_COPIAR_PEDIDO: "continuar.copiar.pedido",
    FILTRAR_PEDIDOS: "filtrar.pedido",
    EC_INTENDED_PRIVATE_ROUTE: "EC.intendedPrivateRoute",
    LISTA_EMPRESAS: "LISTA_EMPRESAS",
    DADOS_USUARIO_LOGADO: "dadosUsuarioLogado",
    ENUMERATIONS: "ENUMERATIONS",
    HEADERS_EMPRESAS: "Header.filtro_empresas",
    PRODUTOS_DASHBOARD: "PRODUTOS_DASHBOARD",
    PEDIDOS_DASHBOARD: "PEDIDOS_DASHBOARD",
  },
  SETTINGS: {
    CANAL: {},
    MAX_PAGINATION: 10,
    CAROUSEL_INTERVAL: 5000,
    SIGLA_EMISSOR: null,
    DEBUG: false,
    TRIAL_INTERVAL: 2000,
    WEINRE_PORT: 3002,
  },
  MESSAGES: {
    DEFAULT_ERROR_MESSAGE: "Não foi possível executar operação.",
  },
};

var appComponents = angular.module("ui-components-app", [
  "ngCookies",
  "angulartics",
  "angulartics.google.analytics",
]);

appComponents.service("fileUpload", [
  "$http",
  function ($http) {
    this.uploadFileToUrl = function (file, uploadUrl) {
      var fd = new FormData();
      fd.append("file", file);
      $http
        .post(uploadUrl, fd, {
          transformRequest: angular.identity,
          headers: { "Content-Type": undefined },
        })
        .success(function () {
          console.log("Arquivo enviado com sucesso!");
        })
        .error(function () {
          console.log("Erro ao realizar upload de arquivo!");
        });
    };
  },
]);

appComponents.service("sessionService", [
  "$cookies",
  "$window",
  "$rootScope",
  function ($cookies, $window, $rootScope) {
    this.getAccessToken = function () {
      this.validateSession();
      return $cookies.accessToken;
    };
    this.getCnpjEC = function () {
      var cnpj;
      if ($rootScope.getActiveEstablishment()) {
        cnpj = $rootScope.getActiveEstablishment().cnpj;
      }
      return cnpj;
    };
    this.validateSession = function () {
      var accessToken = $cookies.accessToken;
      var agjsessionid = $window.sessionStorage.getItem(
        constants.COOKIES.AGJSSESSIONID
      );

      // somente limpa a sessão quando o token nao for ao cookie agjsessionid
      if (agjsessionid !== accessToken) {
        // verifica dominio para limpar sessao
        // (como nao temos um server configurado gerenciando cookies em ambiente de dev, nao precisamos limpar a sessao...)
        if (
          $window.location.hostname.endsWith("vr.com.br") ||
          $window.location.hostname.endsWith("multibeneficiosgpa.com.br")
        ) {
          this.cleanSession();
        }

        $window.sessionStorage.setItem(
          constants.COOKIES.AGJSSESSIONID,
          accessToken
        );
      } else {
        // utilizando try catch para tratar erro de safari (mobile) em modo privado
        // que não permite gravação na sessionstorage
        try {
          $window.sessionStorage.setItem(
            constants.COOKIES.AGJSSESSIONID,
            accessToken
          );
        } catch (e) {
          console.error(
            "ui-components-app: impossível gravar dados no objeto sessionStorage"
          );
          console.error(e);
        }
      }
    };
    this.cleanSession = function () {
      const exceptions = [constants.SESSION.EC_INTENDED_PRIVATE_ROUTE];

      for (var i = 0; i < Object.keys(constants.SESSION).length; i++) {
        if (
          !exceptions.includes(
            constants.SESSION[Object.keys(constants.SESSION)[i]]
          )
        ) {
          $window.sessionStorage.removeItem(
            constants.SESSION[Object.keys(constants.SESSION)[i]]
          );
        }
      }
    };
  },
]);

appComponents.factory("authorizationInjector", [
  "sessionService",
  function (sessionService) {
    return {
      request: function (config) {
        config.headers["access-token"] = sessionService.getAccessToken();
        return config;
      },
    };
  },
]);

appComponents.factory("authHttpResponseInterceptor", [
  "$q",
  "$window",
  "$rootScope",
  "sessionService",
  function ($q, $window, $rootScope, sessionService) {
    return {
      response: function (response) {
        if (response.status === 401) {
          $rootScope.usuarioLogout();
          sessionService.cleanSession();
        }
        return response || $q.when(response);
      },
      responseError: function (rejection) {
        if (rejection.status === 401) {
          $rootScope.usuarioLogout();
          sessionService.cleanSession();
        }
        if (rejection.status === 500) {
          if (rejection.data) {
            if (rejection.data.code === -99 || rejection.data.code === -999) {
              rejection.data.message = constants.MESSAGES.DEFAULT_ERROR_MESSAGE;
            }
            return $q.reject(rejection);
          }
        }
        if (!rejection.data || !rejection.data.messages) {
          rejection.data = {};
          rejection.data.message = constants.MESSAGES.DEFAULT_ERROR_MESSAGE;
        }
        return $q.reject(rejection);
      },
    };
  },
]);

appComponents.factory("vrModalCustomize", [
  "$window",
  function ($window) {
    return {
      toCenter: function (modalInstance) {
        modalInstance.rendered.then(function () {
          var windowHeight = $window.innerHeight;
          var modalNode = document.querySelectorAll(".modal-dialog");
          for (var i = 0; i < modalNode.length; i++) {
            if (windowHeight > modalNode[i].offsetHeight) {
              modalNode[i].style.marginTop =
                (windowHeight - modalNode[i].offsetHeight) / 2 + "px";
            }
          }
        });
      },
    };
  },
]);

appComponents.service("shareDataService", function ($window) {
  var addData = function (key, value) {
    $window.sessionStorage.setItem(key, value);
  };

  var getData = function (key) {
    return $window.sessionStorage.getItem(key);
  };

  return {
    addData: addData,
    getData: getData,
  };
});

appComponents.config([
  "$httpProvider",
  function ($httpProvider) {
    $httpProvider.interceptors.push("authorizationInjector");
    $httpProvider.interceptors.push("authHttpResponseInterceptor");
  },
]);

// definição de funções comuns reutilizaveis em todos os escopos por meio do rootscope
appComponents.run([
  "$rootScope",
  "$window",
  "$http",
  "$timeout",
  "$filter",
  function ($rootScope, $window, $http, $timeout, $filter, sessionService) {
    //////////////////////////////////////////
    // Validações de media queries
    // (tamanhos de tela)
    //////////////////////////////////////////
    $rootScope.isMobileScreen = function () {
      return $window.matchMedia(constants.MEDIA_QUERIES.MOBILE_SCREEN).matches;
    };

    $rootScope.isTabletScreen = function () {
      return $window.matchMedia(constants.MEDIA_QUERIES.TABLET_SCREEN).matches;
    };

    $rootScope.isDesktopScreen = function () {
      return $window.matchMedia(constants.MEDIA_QUERIES.DESKTOP_SCREEN).matches;
    };

    $rootScope.urlQueryValue = function (param) {
      if ($window.location.search) {
        var query = $window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (decodeURIComponent(pair[0]) === param) {
            return decodeURIComponent(pair[1]);
          }
        }
      }
    };

    if (
      $rootScope.urlQueryValue("debug") &&
      $rootScope.urlQueryValue("debug") !== "false"
    ) {
      constants.SETTINGS.DEBUG = true;

      // weinre
      var weinreClientScript = angular.element("<script/>");
      weinreClientScript.attr({
        src:
          "//" +
          $window.location.hostname +
          ":" +
          constants.SETTINGS.WEINRE_PORT +
          "/target/target-script.js#browsersync",
      });
      angular.element(document.head).append(weinreClientScript);

      // pesticide link
      var pesticideLink = angular.element("<link/>");
      pesticideLink.attr({
        rel: "stylesheet",
        type: "text/css",
        href: "/node_modules/pesticide/css/pesticide.min.css",
      });
      angular.element(document.head).append(pesticideLink);

      // pesticide depth link
      var pesticideDepthLink = angular.element("<link/>");
      pesticideDepthLink.attr({
        rel: "stylesheet",
        type: "text/css",
        href: "/node_modules/pesticide/css/pesticide-depth.css",
      });
      angular.element(document.head).append(pesticideDepthLink);

      // grid
      angular
        .element(document.body)
        .addClass("overlay-grid u-debug--overlay-grid");

      // expose root scope
      $window.rootScope = $rootScope;
    }

    // utilizado para debug
    $rootScope.exposeScope = function (controllerName, scope) {
      if (constants.SETTINGS.DEBUG) {
        if ($window[controllerName + "Scope"]) {
          if (!$window[controllerName + "Scope"]["length"]) {
            var existingVar = $window[controllerName + "Scope"];
            $window[controllerName + "Scope"] = [];
            $window[controllerName + "Scope"].push(existingVar);
          }
          $window[controllerName + "Scope"].push(scope);
          console.log(
            controllerName +
              ": objeto $scope acessível em window." +
              controllerName +
              "Scope[" +
              ($window[controllerName + "Scope"].length - 1) +
              "]"
          );
        } else {
          $window[controllerName + "Scope"] = scope;
          console.log(
            controllerName +
              ": objeto $scope acessível em window." +
              controllerName +
              "Scope"
          );
        }
      }
    };
  },
]);

/*
 * FILTROS (inicio)
 */
appComponents.filter("cnpjFilter", function () {
  return function (cnpj) {
    var result = "";

    if (cnpj) {
      var l1 = cnpj.length - 2;
      var l2 = l1 - 4;
      var l3 = l2 - 3;
      var l4 = l3 - 3;

      result = "-" + cnpj.substring(l1);
      result = "/" + cnpj.substring(l2, l1) + result;
      result = "." + cnpj.substring(l3, l2) + result;
      result = "." + cnpj.substring(l4, l3) + result;
      result = cnpj.substring(0, l4) + result;
    }
    return result;
  };
});

appComponents.filter("cpfFilter", function () {
  return function (cpf) {
    var result = "";

    if (cpf) {
      var l1 = cpf.length - 2;
      var l2 = l1 - 3;
      var l3 = l2 - 3;

      result = "-" + cpf.substring(l1);
      result = "." + cpf.substring(l2, l1) + result;
      result = "." + cpf.substring(l3, l2) + result;
      result = cpf.substring(0, l3) + result;
    }
    return result;
  };
});

appComponents.filter("dateSlashFilter", function () {
  return function (dateWithSlash, addSlashes) {
    var output = "",
      day,
      month,
      year;
    dateWithSlash += "";
    if (dateWithSlash) {
      if (addSlashes) {
        day = dateWithSlash.substring(0, 2);
        month = dateWithSlash.substring(2, 4);
        year = dateWithSlash.substring(4);

        output = "" + day + "/" + month + "/" + year;
      } else {
        day = parseInt(dateWithSlash.split("/")[0], 10);
        month = parseInt(dateWithSlash.split("/")[1], 10);
        year = parseInt(dateWithSlash.split("/")[2], 10);

        day = day >= 10 ? "" + day : "0" + day;
        month = month >= 10 ? "" + month : "0" + month;

        output = "" + day + month + year;
      }
    }

    return output;
  };
});

appComponents.filter("telefoneFilter", function () {
  return function (telefone) {
    var output = "";
    if (telefone) {
      var value = telefone.toString().trim().replace(/^\+/, "");

      if (value.match(/[^0-9]/)) {
        return telefone;
      }
      // ex. 1144445555?9
      var ddd = value.slice(0, 2);
      var number = value.slice(2);

      number = number.slice(0, 4) + "-" + number.slice(4);
      output = ("(" + ddd + ") " + number).trim();
    }
    return output;
  };
});

appComponents.filter("cardMask", function () {
  return function (card) {
    var result = "" + card;
    if (card != undefined) {
      card = card.toString();
      if (card) {
        var prefix = card.substring(0, 6);
        var middle = card.substring(6, card.length - 4);
        var suffix = card.substring(card.length - 4, card.length);

        result = prefix;
        for (var i = 0; i < middle.length; i++) {
          result += "X";
        }
        result += suffix;
      }
    }
    return result;
  };
});

appComponents.filter("cardEnd", function () {
  return function (card) {
    var result = "!cardEnd: " + card;
    card = card.toString();
    if (card) {
      result = card.substring(card.length - 4);
    }
    return result;
  };
});

appComponents.filter("indexFilter", function () {
  return function (array, item) {
    var result = "";
    if (array && item) {
      result = array.indexOf(item);
    }
    return result;
  };
});

appComponents.filter("lengthFilter", function () {
  return function (array) {
    var result = "";
    if (array) {
      result = array.length;
    }
    return result;
  };
});

appComponents.filter("fromArrayToReadableString", function () {
  return function (array) {
    var result = "";
    if (array) {
      for (var i = 0; i < array.length; i++) {
        result += array[i];
        if (i === array.length - 2) {
          result += " e ";
        } else if (i !== array.length - 1) {
          result += ", ";
        }
      }
    }
    return result;
  };
});

appComponents.filter("monthNumberToName", function () {
  return function (month) {
    var monthNameList = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ];

    return monthNameList[month - 1];
  };
});

appComponents.filter("filteredFullSearch", function () {
  return function (collection, criteria, criteriaName1, criteriaName2) {
    var output = [];

    if (criteriaName2) {
      if (criteria) {
        var isEqual = true;
        angular.forEach(collection, function (value, key) {
          if (angular.isArray(value[criteriaName1])) {
            isEqual = false;
            angular.forEach(value[criteriaName1], function (item, index) {
              if (item[criteriaName2] === criteria) {
                isEqual = true;
              }
            });
          } else {
            isEqual = true;
            angular.forEach(
              value[criteriaName1][criteriaName2],
              function (item, key) {
                if (item !== criteria[key]) {
                  isEqual = false;
                }
              }
            );
          }

          if (isEqual) output.push(value);
        });
      } else {
        output = collection;
      }
    } else {
      if (criteria) {
        angular.forEach(collection, function (value, key) {
          var isEqual = true;
          angular.forEach(value[criteriaName1], function (item, key) {
            if (item !== criteria[key]) {
              isEqual = false;
            }
          });

          if (isEqual) output.push(value);
        });
      } else {
        output = collection;
      }
    }

    return output;
  };
});

/**
 * Diretiva para loading dos paineis!
 * vr-loading-panel="true || false"
 * True mostra e False esconde!
 **/
appComponents.directive("vrLoadingPanel", [
  function () {
    return {
      scope: {
        vrLoadingPanel: "=",
      },
      restrict: "AE",
      template:
        '<section class="panel-loading" ng-show="vrLoadingPanel"><div class="panel-loading-bar"></div></section>',
      replace: true,
      link: function ($scope) {
        $scope.$watch("vrLoadingPanel", function () {
          // nao faz nada dentro do watch
        });
      },
    };
  },
]);

/**
 * Diretiva para comparar senhas por exemplo compare-to=model
 **/
appComponents.directive("compareTo", function () {
  return {
    require: "ngModel",
    scope: {
      otherModelValue: "=compareTo",
    },
    link: function (scope, element, attributes, ngModel) {
      ngModel.$validators.compareTo = function (modelValue) {
        return modelValue == scope.otherModelValue;
      };

      scope.$watch("otherModelValue", function () {
        ngModel.$validate();
      });
    },
  };
});

/**
 * Diretiva de validação de datas
 */
appComponents.directive("dateValidation", function () {
  return {
    require: "ngModel",
    link: function (scope, element, attributes, ngModel) {
      ngModel.$validators.dateValidation = function (modelValue) {
        var isValid = false;

        if (modelValue) {
          var stringValue = modelValue.toString();
          // remove as '/' se tiver
          if (stringValue.indexOf("/") > -1) {
            var reg = /\//g;
            stringValue = stringValue.replace(reg, "");
          }
          if (stringValue.length >= 7) {
            var l1 = stringValue.length - 4;
            var l2 = l1 - 2;
            var year = parseInt(stringValue.substring(l1), 10);
            var month = parseInt(stringValue.substring(l2, l1), 10);
            var day = parseInt(stringValue.substring(0, l2), 10);

            // validação de ano
            var date = new Date();
            var yearValid = year >= 1900 && year <= date.getFullYear();

            // validação de mês
            var monthValid = month >= 1 && month <= 12;

            // validação de dia
            date = new Date(year, month, 0);
            var lastDayInMonth = date.getDate();
            var dayValid = day >= 1 && day <= lastDayInMonth;

            isValid = yearValid && monthValid && dayValid;
          }
        }

        return isValid;
      };
    },
  };
});

/**
 * Diretiva de validação de datas
 */
appComponents.directive("dateValidationOnlyFilled", function () {
  return {
    require: "ngModel",
    link: function (scope, element, attributes, ngModel) {
      ngModel.$validators.dateValidation = function (modelValue) {
        var isValid = true;

        if (modelValue) {
          var stringValue = modelValue.toString();
          // remove as '/' se tiver
          if (stringValue.indexOf("/") > -1) {
            var reg = /\//g;
            stringValue = stringValue.replace(reg, "");
          }
          if (stringValue.length >= 7) {
            var l1 = stringValue.length - 4;
            var l2 = l1 - 2;
            var year = parseInt(stringValue.substring(l1), 10);
            var month = parseInt(stringValue.substring(l2, l1), 10);
            var day = parseInt(stringValue.substring(0, l2), 10);

            // validação de ano
            var date = new Date();
            var yearValid = year >= 1900 && year <= date.getFullYear();

            // validação de mês
            var monthValid = month >= 1 && month <= 12;

            // validação de dia
            date = new Date(year, month, 0);
            var lastDayInMonth = date.getDate();
            var dayValid = day >= 1 && day <= lastDayInMonth;

            isValid = yearValid && monthValid && dayValid;
          }
        }

        return isValid;
      };
    },
  };
});

/**
 * Diretiva de validação de data igual ou maior a data atual
 */
appComponents.directive("futureDateValidation", function () {
  return {
    require: "ngModel",
    link: function (scope, element, attributes, ngModel) {
      ngModel.$validators.futureDateValidation = function (modelValue) {
        var isValid = false;

        if (modelValue) {
          var stringValue = modelValue.toString();
          // remove as '/' se tiver
          if (stringValue.indexOf("/") > -1) {
            var reg = /\//g;
            stringValue = stringValue.replace(reg, "");
          }
          if (stringValue.length >= 7) {
            var l1 = stringValue.length - 4;
            var l2 = l1 - 2;
            var year = parseInt(stringValue.substring(l1), 10);
            var month = parseInt(stringValue.substring(l2, l1), 10);
            var day = parseInt(stringValue.substring(0, l2), 10);

            var currentTime = new Date();
            var currentMonth = currentTime.getMonth() + 1;
            var currentDay = currentTime.getDate();
            var currentYear = currentTime.getFullYear();

            //validação ano
            var yearValid = currentYear >= year;

            // validação de mês
            var monthValid = currentMonth >= month;

            var dayValid = month > currentMonth ? true : day >= currentDay;

            isValid = yearValid && monthValid && dayValid;
          }
        }

        return isValid;
      };
    },
  };
});

/**
 * Diretiva de validação de data igual ou menor a data atual
 */
appComponents.directive("notFutureDateValidation", function () {
  return {
    require: "ngModel",
    link: function (scope, element, attributes, ngModel) {
      ngModel.$validators.notFutureDateValidation = function (modelValue) {
        var isValid = true;

        if (modelValue) {
          var stringValue = modelValue.toString();
          // remove as '/' se tiver
          if (stringValue.indexOf("/") > -1) {
            var reg = /\//g;
            stringValue = stringValue.replace(reg, "");
          }
          if (stringValue.length >= 7) {
            var l1 = stringValue.length - 4;
            var l2 = l1 - 2;
            var year = parseInt(stringValue.substring(l1), 10);
            var month = parseInt(stringValue.substring(l2, l1), 10);
            var day = parseInt(stringValue.substring(0, l2), 10);

            var currentTime = new Date();
            var currentMonth = currentTime.getMonth() + 1;
            var currentDay = currentTime.getDate();
            var currentYear = currentTime.getFullYear();

            //validação ano
            var yearValid = year <= currentYear;

            // validação de mês
            var monthValid =
              year < currentYear ||
              (year == currentYear && month <= currentMonth);

            var dayValid =
              year < currentYear ||
              (year == currentYear && month < currentMonth) ||
              (year == currentYear &&
                month == currentMonth &&
                day <= currentDay);

            isValid = yearValid && monthValid && dayValid;
          }
        }

        return isValid;
      };
    },
  };
});

appComponents.directive("numberValidation", function () {
  return {
    require: "ngModel",
    link: function (scope, element, attributes, ngModel) {
      ngModel.$validators.numberValidation = function (modelValue) {
        var regex = /^\d+$/;
        return regex.test(modelValue);
      };
    },
  };
});

appComponents.directive("specialCharValidation", function () {
  return {
    require: "ngModel",
    scope: {
      acceptPeriodCommaOrColon: "=specialCharValidation",
    },
    link: function (scope, element, attributes, ngModel) {
      ngModel.$validators.specialCharValidation = function (modelValue) {
        var regex;
        if (!scope.acceptPeriodCommaOrColon) {
          regex = /^[\d\w\s]*$/;
        } else {
          regex = /^[A-Za-z0-9\s]*$/gm;
        }
        return regex.test(modelValue);
      };
    },
  };
});

appComponents.directive("fileExtensionValidation", function () {
  return {
    require: "ngModel",
    scope: {
      extensions: "=fileExtensionValidation",
    },
    link: function (scope, element, attributes, ngModel) {
      ngModel.$validators.fileExtensionValidation = function (modelValue) {
        var isValid = false;

        if (modelValue) {
          for (var i = 0; i < scope.extensions.length && !isValid; i++) {
            isValid = modelValue.endsWith(scope.extensions[i]);
          }
        } else {
          // regra de aceitação para valores nulos
          isValid = true;
        }

        return isValid;
      };
    },
  };
});

/**
 * Diretiva de prevenção de área de transferência
 */
appComponents.directive("noCutCopyPaste", function () {
  return {
    link: function (scope, element) {
      element.on("cut copy paste", function (event) {
        event.preventDefault();
      });
    },
  };
});

appComponents.directive("positiveNumberValidation", function () {
  return {
    require: "ngModel",
    scope: {
      acceptZeroOrUndefined: "=positiveNumberValidation",
    },
    link: function (scope, element, attributes, ngModel) {
      ngModel.$validators.positiveNumberValidation = function (modelValue) {
        var isValid = false;

        if (scope.acceptZeroOrUndefined) {
          isValid =
            modelValue === undefined || modelValue === null || modelValue >= 0;
        }

        if (modelValue) {
          modelValue = parseFloat(modelValue, 10);
          if (modelValue > 0) {
            isValid = true;
          }
        }

        return isValid;
      };
    },
  };
});

/**
 * Diretiva para comparar numeros
 **/
appComponents.directive("greaterThan", function () {
  return {
    require: "ngModel",
    scope: {
      otherModelValue: "=greaterThan",
    },
    link: function (scope, element, attributes, ngModel) {
      ngModel.$validators.greaterThan = function (modelValue) {
        return modelValue > scope.otherModelValue;
      };

      scope.$watch("otherModelValue", function () {
        ngModel.$validate();
      });
    },
  };
});

appComponents.directive("range", function () {
  return {
    restric: "E",
    transclude: true,
    scope: {
      bindModel: "=ngModel",
      name: "@name",
    },
    template:
      '<div class="range-wrapper">' +
      "<ul>" +
      "<li>25%</li>" +
      "<li>50%</li>" +
      "<li>75%</li>" +
      "<li>100%</li>" +
      "</ul>" +
      '<input name="{{name}}" ng-model="bindModel" type="range" min="25" max="100" step="25" list="range" value="25">' +
      "</div>",
  };
});

appComponents.directive("customTooltip", function () {
  return {
    restrict: "A",
    link: function (scope, element, attrs) {
      $(element).hover(
        function () {
          // on mouseenter
          $(element).tooltip("show");
        },
        function () {
          // on mouseleave
          $(element).tooltip("hide");
        }
      );
    },
  };
});

/**
 * Diretiva de tooltip
 *
 * div vr-tooltip-closeable='texto'
 **/
appComponents.directive("vrTooltipCloseable", [
  function () {
    return {
      restrict: "AE",
      replace: true,
      transclude: true,
      scope: {
        text: "=vrTooltipCloseable",
        tooltipModifierClass: "=?tooltipModifierClass",
        visible: "=?showTip",
        inputType: "=?",
        inputPlaceholder: "=?",
        inputCallback: "&?",
      },
      templateUrl: function (element, attrs) {
        var defaultTemplateURL = null;
        if (attrs.inputType) {
          defaultTemplateURL =
            "/portal/app/components/partials/directives/vr-tooltip-input-closeable.html";
        } else {
          defaultTemplateURL =
            "/portal/app/components/partials/directives/vr-tooltip-closeable.html";
        }
        return attrs.templateUrl || defaultTemplateURL;
      },
      link: function (scope) {
        scope.$watch("visible", function (value) {
          if (value === undefined) {
            scope.visible = true;
          }
        });

        scope.toggle = function () {
          scope.visible = !scope.visible;
        };
      },
    };
  },
]);

/**
 * Diretiva de alerta!
 * vr-alert="Texto"
 **/
appComponents.directive("vrAlert", [
  "$document",
  function ($document) {
    return {
      scope: {
        vrAlert: "=",
        vrAlertType: "=",
      },
      restrict: "AE",
      templateUrl: function (element, attrs) {
        return (
          attrs.templateUrl ||
          "/portal/app/components/partials/directives/vr-alert.html"
        );
      },
      replace: true,
      link: function ($scope, iElm, iAttrs, controller) {
        var pagesToIgnoreEffect = [
          "esqueci-minha-senha.html",
          "esqueci-meu-email.html",
          "login/",
        ];
        var templateInline = iAttrs.templateInline;
        $scope.alertDisplay = true;
        $scope.templateInline = templateInline;

        if (templateInline) {
          var contentElementV1 = iElm[0].querySelector("#vr-alert-content");
          contentElementV1.innerHTML = templateInline;
        }

        $scope.$watch("vrAlert", function (newValue, oldValue, scope) {
          if (scope.templateInline) {
            scope.vrAlert = scope.templateInline;
            if ($scope.isApplyEffectToCurrentPage()) {
              $document.scrollToElementAnimated(iElm, 100);
            }
          }
        });

        $scope.isApplyEffectToCurrentPage = function () {
          var isApplyEffect = true;
          angular.forEach(pagesToIgnoreEffect, function (item, key) {
            if (window.location.href.endsWith(item)) {
              isApplyEffect = false;
            }
          });
          return isApplyEffect;
        };

        $scope.dismiss = function () {
          $scope.alertDisplay = false;
        };
      },
    };
  },
]);

/**
 * DIRETIVA DE NAVEGAÇÃO EM TAB
 **/
appComponents.directive("navTabs", [
  "$window",
  "$timeout",
  function ($window, $timeout) {
    return {
      scope: {
        navTabs: "=",
      },
      restrict: "A",
      replace: true,
      template: '<nav class="tabs" role="navigation"></nav>',
      transclude: true,
      link: function ($scope, iElm, iAttrs, controller, transclude) {
        iElm.append(transclude());
        var wrapper = iElm[0].querySelector(".tabs-wrapper");
        var tabs = iElm[0].querySelectorAll(".tab");
        var tab = tabs[0];

        if (!tabs || !wrapper) return false;

        var leftButton = iElm[0].querySelectorAll(".tab-navigation")[0];
        var rightButton = iElm[0].querySelectorAll(".tab-navigation")[1];
        var selectionIndex = 0;
        var maxIndex = tabs.length - 1;
        var displayArrows = false;

        angular.element(tabs).on("click", function (event) {
          tab = event.target;
          toggleActive(tab);
        });

        angular.element(leftButton).on("click", goBack);
        angular.element(rightButton).on("click", goNext);
        angular.element(rightButton).addClass("hidden");
        angular.element(leftButton).addClass("hidden");

        function detectWidth() {
          if (wrapper.clientWidth < wrapper.scrollWidth) {
            displayArrows = true;
            toggleActive(tab);
          } else {
            displayArrows = false;
            $timeout(function () {
              angular.element(leftButton).addClass("hidden");
              angular.element(rightButton).addClass("hidden");
            });
          }
        }

        $window.addEventListener("resize", detectWidth);
        detectWidth();

        function toggleActive(tab) {
          $timeout(function () {
            $scope.navTabs = tab.innerHTML;
          });

          //Muda pra active
          angular.element(tabs).removeClass("active");
          angular.element(tab).addClass("active");

          //Verifica o selecionado para mudar o index
          for (var i = 0; i < tabs.length; i++) {
            if (tabs[i].className.indexOf("active") != -1) {
              selectionIndex = i;
              break;
            }
          }

          //Move a div
          var offset = tab.offsetLeft;
          wrapper.scrollLeft = offset;

          //Toogle do botão de navegação da esquerda
          if (tabs[0].className.indexOf("active") != -1) {
            angular.element(leftButton).addClass("hidden");
          } else if (displayArrows) {
            angular.element(leftButton).removeClass("hidden");
          }
          //Toggle do botão de navegação da direita
          if (tabs[tabs.length - 1].className.indexOf("active") != -1) {
            angular.element(rightButton).addClass("hidden");
          } else if (displayArrows) {
            angular.element(rightButton).removeClass("hidden");
          }
        }

        function goNext() {
          if (selectionIndex < maxIndex) {
            selectionIndex++;
            //toggleActive(tabs[selectionIndex]);
          }
        }

        function goBack() {
          if (selectionIndex > 0) {
            selectionIndex--;
            //toggleActive(tabs[selectionIndex]);
          }
        }

        toggleActive(tab);
      },
    };
  },
]);

/**
 * DIRETIVA PARA ATUALIZAÇÃO DE ATIVAÇÃO
 **/
appComponents.directive("updateActive", function () {
  return {
    restrict: "A",
    link: function ($scope, iElm, Attrs, Ctrl) {
      var el = iElm[0];
      el.onclick = function () {
        angular.forEach(el.parentNode.children, function (node) {
          angular.element(node).removeClass("active");
        });

        angular.element(el).addClass("active");
      };
    },
  };
});

/**
 * DROPDOWN DO MENU
 **/
appComponents.directive("dropdownHover", [
  "$timeout",
  function ($timeout) {
    return {
      scope: {
        dropdownHover: "@",
      },
      restrict: "A",
      link: function ($scope, iElm, Attrs, Ctrl) {
        var dropWrapper = document.querySelector("#" + $scope.dropdownHover);
        if (!dropWrapper) return false;
        var el = iElm[0];
        var timelimit = 100;
        var openTimeout;
        var hoveringElement = false;

        var startHover = function (e) {
          dropWrapper.style.display = "block";
          hoveringElement = true;
        };

        var leaveHover = function (e) {
          var nextObject = e.toElement || e.relatedTarget;
          hoveringElement = false;

          $timeout(function () {
            if (!hoveringElement) {
              dropWrapper.style.display = "none";
            }
          }, timelimit);
        };

        angular.element(el).on("mouseenter", startHover);
        angular.element(dropWrapper).on("mouseenter", startHover);
        angular.element(el).on("mouseleave", leaveHover);
        angular.element(dropWrapper).on("mouseleave", leaveHover);
      },
    };
  },
]);

appComponents.directive("fileModel", [
  "$parse",
  function ($parse) {
    return {
      restrict: "A",
      link: function (scope, element, attrs) {
        var model = $parse(attrs.fileModel);
        var modelSetter = model.assign;

        element.bind("change", function () {
          scope.$apply(function () {
            modelSetter(scope, element[0].files[0]);
          });
        });
      },
    };
  },
]);

appComponents.directive("vrPagination", [
  function () {
    return {
      scope: {
        page: "=",
        pageQuantity: "=",
        pageLimit: "=",
        pageChangeRequest: "=",
      },
      restrict: "A",
      templateUrl: function (element, attrs) {
        return (
          attrs.templateUrl ||
          "/portal/app/components/partials/directives/vr-pagination.html"
        );
      },
      replace: true,
      link: function ($scope) {
        $scope.showLeftPaginationArrow = function () {
          return (
            $scope.pagination &&
            $scope.pagination.length > 0 &&
            $scope.page > 1 &&
            $scope.pageQuantity > $scope.pageLimit
          );
        };

        $scope.showRightPaginationArrow = function () {
          return (
            $scope.pagination &&
            $scope.pagination.length > 0 &&
            !($scope.pageQuantity - $scope.page < $scope.pageLimit)
          );
        };

        $scope.changePage = function (pageNumber) {
          $scope.pageChangeRequest(pageNumber);
          $scope.page = pageNumber;
        };

        $scope.$watchGroup(
          ["page", "pageQuantity", "pageLimit", "pageChangeRequest"],
          function () {
            $scope.pagination = [];
            if ($scope.pageQuantity) {
              if ($scope.pageQuantity > $scope.pageLimit) {
                if ($scope.pageQuantity - $scope.page < $scope.pageLimit) {
                  // situacao de exceçao: ultimos itens da lista
                  for (
                    var j = $scope.pageQuantity - $scope.pageLimit + 1;
                    j <= $scope.pageQuantity;
                    j++
                  ) {
                    $scope.pagination.push({
                      page: j,
                    });
                  }
                } else {
                  // situacao normal, todos os itens de 1 até os ultimos x
                  for (
                    var i = 0;
                    i < constants.SETTINGS.MAX_PAGINATION + 1 &&
                    i < $scope.pageQuantity;
                    i++
                  ) {
                    $scope.pagination.push({
                      page: $scope.page + i,
                    });
                  }
                }
              } else {
                for (var k = 1; k <= $scope.pageQuantity; k++) {
                  $scope.pagination.push({
                    page: k,
                  });
                }
              }
            }
          }
        );
      },
    };
  },
]);

//diretiva para possibilitar o init dos dados recebidos do Lumis no Angular (forms)
appComponents.directive("vrInitial", function () {
  return {
    restrict: "A",
    controller: [
      "$scope",
      "$element",
      "$attrs",
      "$parse",
      "$filter",
      function ($scope, $element, $attrs, $parse, $filter) {
        var getter = $parse($attrs.ngModel),
          setter,
          val;
        val = $attrs.vrInitial || $attrs.value;

        // tratamento de inputs com filtro
        if (val && val.indexOf("|") > -1) {
          var filterName = val
            .replace("{{", "")
            .replace("}}", "")
            .split("|")[1]
            .split(":")[0];
          var filterAttribute = val
            .replace("{{", "")
            .replace("}}", "")
            .split("|")[1]
            .split(":")[1];
          var input = val.replace("{{", "").replace("}}", "").split("|")[0];
          if (filterAttribute) {
            val = $filter(filterName.trim())(
              input.trim(),
              filterAttribute.trim()
            );
          } else {
            val = $filter(filterName.trim())(input.trim());
          }
        }

        // tratamento de inputs radio
        if ($element[0].type === "radio") {
          val = val === "checked" ? $attrs.value : "";
        }

        // tratamento de inputs de select>option
        if ($element[0].tagName.toLowerCase() === "option") {
          getter = $parse(
            $element[0].parentElement.attributes["ng-model"].value
          );
          val = $element[0].value;
        }

        if (val && val.length > 0) {
          setter = getter.assign;
          setter($scope, val);
        }
      },
    ],
  };
});

// diretiva de manipulação de tecla enter para forms (somente formularios validos podem continuar)
appComponents.directive("vrEnterKeyFormInterceptor", function () {
  return {
    restrict: "A",
    link: function (scope, element) {
      angular.element(element).on("keypress keyup", function (e) {
        var keyCode = e.keyCode || e.which;
        var pressedReturn = keyCode === 13;
        var formName = angular.element(element).attr("name");
        if (formName) {
          var formIsInvalid = angular.element(element).scope()[
            formName
          ].$invalid;
          if (pressedReturn && formIsInvalid) {
            if (constants.SETTINGS.DEBUG) {
              console.error(
                "Capturada tecla enter, porém o form " +
                  formName +
                  " está marcado como inválido:"
              );
              console.dir(angular.element(element).scope()[formName].$error);
            }

            // evento de enter em text area pode passar
            if (e.target.tagName.toLowerCase() !== "textarea") {
              e.preventDefault();
            }
          }

          if (pressedReturn && !formIsInvalid) {
            var callback = angular
              .element(element)
              .attr("vr-enter-key-form-interceptor");

            if (callback && callback.length > 0) {
              if (constants.SETTINGS.DEBUG) {
                console.log(
                  "A função " +
                    callback +
                    " foi passada como parâmetro e será executada..."
                );
              }
              callback = callback.replace("()", "");
              angular.element(element).scope()[callback].call();
            } else {
              if (constants.SETTINGS.DEBUG) {
                console.log(
                  "Nenhuma função de callback foi passada como parâmetro"
                );
              }
              var submitButton = angular
                .element("form[name=" + formName + "]")
                .find("button[type=submit]");
              if (submitButton && submitButton.length > 0) {
                if (constants.SETTINGS.DEBUG) {
                  console.log(
                    "Encontrado botão de submit, simulando click desse botão..."
                  );
                }
                submitButton[0].click();
              }
            }
          }
        }
      });
    },
  };
});

appComponents.directive("vrTransientImage", function ($q) {
  var URL = window.URL || window.webkitURL;

  var getResizeArea = function () {
    var resizeAreaId = "fileupload-resize-area";

    var resizeArea = document.getElementById(resizeAreaId);

    if (!resizeArea) {
      resizeArea = document.createElement("canvas");
      resizeArea.id = resizeAreaId;
      resizeArea.style.visibility = "hidden";
      document.body.appendChild(resizeArea);
    }

    return resizeArea;
  };

  var resizeImage = function (origImage, options) {
    var maxHeight = options.resizeMaxHeight || 300;
    var maxWidth = options.resizeMaxWidth || 250;
    var quality = options.resizeQuality || 0.7;
    var type = options.resizeType || "image/jpg";

    var canvas = getResizeArea();

    var height = origImage.height;
    var width = origImage.width;

    // calculate the width and height, constraining the proportions
    if (width > height) {
      if (width > maxWidth) {
        height = Math.round((height *= maxWidth / width));
        width = maxWidth;
      }
    } else {
      if (height > maxHeight) {
        width = Math.round((width *= maxHeight / height));
        height = maxHeight;
      }
    }

    canvas.width = width;
    canvas.height = height;

    //draw image on canvas
    var ctx = canvas.getContext("2d");
    ctx.drawImage(origImage, 0, 0, width, height);

    // get the data from canvas as 70% jpg (or specified type).
    return canvas.toDataURL(type, quality);
  };

  var createImage = function (url, callback) {
    var image = new Image();
    image.onload = function () {
      callback(image);
    };
    image.src = url;
  };

  var fileToDataURL = function (file) {
    var deferred = $q.defer();
    var reader = new FileReader();
    reader.onload = function (e) {
      deferred.resolve(e.target.result);
    };
    reader.readAsDataURL(file);
    return deferred.promise;
  };

  return {
    restrict: "A",
    scope: {
      vrTransientImage: "=",
      emitEvent: "@?",
      resizeMaxHeight: "@?",
      resizeMaxWidth: "@?",
      resizeQuality: "@?",
      resizeType: "@?",
    },
    link: function postLink(scope, element, attrs, ctrl) {
      var doResizing = function (imageResult, callback) {
        createImage(imageResult.url, function (image) {
          var dataURL = resizeImage(image, scope);
          imageResult.resized = {
            dataURL: dataURL,
            type: dataURL.match(/:(.+\/.+);/)[1],
          };
          callback(imageResult);
        });
      };

      var applyScope = function (imageResult) {
        scope.$apply(function () {
          scope.$emit(attrs.emitevent, imageResult);
          if (attrs.multiple) {
            scope.vrTransientImage.push(imageResult);
          } else {
            scope.vrTransientImage = imageResult;
          }
        });
      };

      element.bind("change", function (evt) {
        //when multiple always return an array of images
        if (attrs.multiple) {
          scope.vrTransientImage = [];
        }

        var files = evt.target.files;
        for (var i = 0; i < files.length; i++) {
          //create a result object for each file in files
          var imageResult = {
            file: files[i],
            url: URL.createObjectURL(files[i]),
          };

          fileToDataURL(files[i]).then(function (dataURL) {
            imageResult.dataURL = dataURL;
          });

          if (scope.resizeMaxHeight || scope.resizeMaxWidth) {
            //resize image
            doResizing(imageResult, function (imageResult) {
              applyScope(imageResult);
            });
          } else {
            //no resizing
            applyScope(imageResult);
          }
        }
      });
    },
  };
});

appComponents.directive("vrFileInput", [
  function () {
    return {
      link: function (scope, element, attrs) {
        var callback = attrs.vrFileInput;
        if (callback && callback.length > 0) {
          callback = callback.replace("()", "");
        }
        element.on("change", function (event) {
          scope.$apply();
          if (callback) {
            if (constants.SETTINGS.DEBUG) {
              console.log(
                "A função " +
                  callback +
                  " foi passada como parâmetro e será executada..."
              );
            }
            angular.element(element).scope()[callback].call();
          }
        });
      },
    };
  },
]);

/**
 * DIRETIVA PARA CONTROLE DE EXIBIÇÃO DE POPOVER
 **/

appComponents.directive("vrPopoverButton", function () {
  return {
    restrict: "A",
    replace: false,
    link: function (scope, elem) {
      var triggerElem = angular.element(elem).find('[rel="popover"]');

      triggerElem.hover(function () {
        angular.element(elem).find(".c-popover").toggleClass("is-open");
      });
    },
  };
});

/**
 * DIRETIVA LIMPAR CONTROLES DE FORMULÁRIO
 **/

appComponents.directive("vrClearInput", function () {
  return {
    restrict: "E",
    templateUrl:
      "/portal/app/components/partials/directives/vr-select-clear-button.html",
    scope: {
      inputModel: "=",
    },
    replace: false,
    link: function (scope, elem) {
      angular.element(elem).on("click", function (e) {
        e.preventDefault();
        scope.inputModel = null;
        scope.$apply();
      });
    },
  };
});

/**
 * DIRETIVA PARA CONTROLE DE EXIBIÇÃO DE DROPDOWN
 **/

appComponents.directive("vrDropdownComponent", function () {
  return {
    restrict: "A",
    replace: "false",
    link: function (scope, elem) {
      var parentElem = angular.element(elem),
        dropdownTriggerElem = parentElem.find('[rel="trigger"]'),
        dropdownElem = parentElem.find(".c-dropdown");

      dropdownTriggerElem.on("click", function (e) {
        e.preventDefault();
        dropdownElem.toggleClass("is-open");
      });

      // Fecha dropdown qndo ocorre qualquer clique fora do elemento.
      var handleOuterClick = function (e) {
        if (!parentElem.is(e.target) && parentElem.has(e.target).length === 0) {
          dropdownElem.removeClass("is-open");
        }
      };

      angular.element("html").on("click", handleOuterClick);

      scope.$on("$destroy", function () {
        angular.element("html").off("click", handleOuterClick);
      });
    },
  };
});

/**
 * DIRETIVA PARA FILTROS DE ORDENAÇÃO DO COMPONENTE DATA-TABLE
 **/

appComponents.directive("vrDataTableFilter", [
  function () {
    return {
      restrict: "A",
      templateUrl:
        "/portal/app/components/partials/directives/vr-data-table-filter.html",
      replace: "true",
      scope: {
        modelCount: "=",
        filterAction: "&",
        filterModel: "=",
        filterOptions: "=",
        filterContext: "=", //substring para diferenciar id's utilizadas em inputs da diretiva
        singularLabel: "=",
        pluralLabel: "=",
      },
      link: function (scope, elem) {
        var dropdown;

        elem.find(".c-filter__trigger").bind("click", function () {
          var selfDropdown = angular.element(this).parent().find(".c-dropdown");
          elem.find(".c-dropdown").not(selfDropdown).removeClass("is-open");
          selfDropdown.toggleClass("is-open");
        });

        scope.getColumnLabel = function () {
          if (scope.filterOptions.columns) {
            for (var i = 0; i < scope.filterOptions.columns.length; i++) {
              if (
                scope.filterOptions.columns[i].value ===
                scope.filterModel.columns
              )
                return scope.filterOptions.columns[i].label;
            }
          }
        };

        // Fecha dropdown qndo ocorre qualquer clique fora do elemento.
        var clickTarget = elem.find(".c-filter");

        var handleOuterClick = function (e) {
          if (
            !clickTarget.is(e.target) &&
            clickTarget.has(e.target).length === 0
          ) {
            elem.find(".c-dropdown").removeClass("is-open");
          }
        };

        scope.$on("$destroy", function () {
          angular.element("html").off("click", handleOuterClick);
        });

        angular.element("html").on("click", handleOuterClick);
      },
    };
  },
]);

appComponents.directive("vrPanelPagination", [
  function () {
    return {
      restrict: "A",

      templateUrl:
        "/portal/app/components/partials/directives/vr-panel-pagination.html",
      replace: "true",
      scope: {
        currentPageNumber: "=",
        totalPagesNumber: "=",
        nextAction: "&",
        prevAction: "&",
        pluralLabel: "=",
      },
    };
  },
]);

appComponents.controller("CarouselController", [
  "$scope",
  function ($scope) {
    $scope.interval = constants.SETTINGS.CAROUSEL_INTERVAL;
    $scope.activeIndex = 0;

    if (constants.SETTINGS.DEBUG) {
      $scope.exposeScope("CarouselController", $scope);
    }
  },
]);

/**
 * Nova diretiva de alerta
 * <vrNotice vrtype="warning | danger | success | info">
 */
appComponents.directive("vrNotice", function () {
  return {
    scope: {
      vrtype: "@",
      iconpath: "@",
    },
    restrict: "E",
    templateUrl: "/portal/app/components/partials/directives/vr-notice.html",
    transclude: true,
    link: (scope) => {
      // Pegar o icone de acordo com o vrtype
      scope.getIcon = () => {
        return `<svg width="34" height="30"><use xlink:href="#notice-${scope.vrtype}" /></svg>`;
      };
    },
  };
});

/**
 * Diretiva de modal
 * a diretiva consiste basicamente em um titulo passado pelo atributo
 * e um texto dentro da propria diretiva, que será a mensagem de alerta.
 * Caso seja necessário a utilização de botões, basta passar o texto no
 * atributo btn correspondente.
 * Também pode ser passado uma função de ação para cada botão.
 */
appComponents.directive("vrModal", function () {
  return {
    scope: {
      title: "@",
      successText: "@",
      cancelText: "@",
      successAction: "&",
      cancelAction: "&",
    },
    restrict: "E",
    templateUrl: "/portal/app/components/partials/directives/vr-modal.html",
    transclude: true,
    link: (scope, elem) => {
      scope.closeModal = () => {
        elem.remove();
      };
    },
  };
});

appComponents.directive("vrHeader", function ($http, $window) {
  return {
    scope: {},
    restrict: "E",
    link: () => {
      const directiveEl = document.getElementById("header");
      directiveEl.innerHTML =
        '<header class="loading-model"><section></section><section></section></header>';

      $http
        .get("/apps/comum/ui-header/asset-manifest.json")
        .then((response) => {
          const { data } = response;
          const scriptElement = document.createElement("script");

          scriptElement.src = data.files["main.js"];
          $window.document.body.appendChild(scriptElement);
        });
    },
  };
});

// Diretiva para carregar os locais de entrega
appComponents.directive("vrLocalEntregaTest", function ($http, $window) {
  return {
    scope: {},
    restrict: "E",
    link: () => {
      $http
        .get("/apps/rh/locais-entrega/asset-manifest.json")
        .then((response) => {
          const { data } = response;
          const scriptElement = document.createElement("script");
          scriptElement.src =
            "/apps/rh/locais-entrega/" + data.files["main.js"];
          $window.document.body.appendChild(scriptElement);
        });
    },
  };
});

// Diretiva para carregar os meus-pedidos
appComponents.directive("vrGestaoPedidos", function ($http, $window) {
  return {
    scope: {},
    restrict: "E",
    link: () => {
      $http
        .get("/apps/rh/meus-pedidos/asset-manifest.json")
        .then((response) => {
          const { data } = response;
          const scriptElement = document.createElement("script");
          scriptElement.src = data.files["main.js"];
          $window.document.body.appendChild(scriptElement);
        });
    },
  };
});

appComponents.directive("vrFooter", function ($http, $window) {
  return {
    scope: {},
    restrict: "E",
    link: () => {
      $http
        .get("/portal/app/ui-footer/asset-manifest.json")
        .then((response) => {
          const { data } = response;
          const scriptElement = document.createElement("script");

          scriptElement.src = data.files["main.js"];
          $window.document.body.appendChild(scriptElement);
        });
    },
  };
});

appComponents.controller("CarouselController", [
  "$scope",
  function ($scope) {
    $scope.interval = constants.SETTINGS.CAROUSEL_INTERVAL;
    $scope.activeIndex = 0;

    if (constants.SETTINGS.DEBUG) {
      $scope.exposeScope("CarouselController", $scope);
    }
  },
]);

/**
 * Área de subheader usando o dado para ativar o elemento
 **/
appComponents.controller("SubNavigation", [
  "$scope",
  "$window",
  "$uibModal",
  function ($scope, $window, $uibModal) {
    var paths = $window.location.pathname.split("/");
    var actualPath = paths[paths.length - 1] || "";
    actualPath = actualPath.replace(".html", "");
    this.pageView = function (pageView) {
      return actualPath == pageView;
    };

    if (constants.SETTINGS.DEBUG) {
      $scope.exposeScope("SubNavigation", $scope);
    }

    $scope.openMaterialApoioModal = function () {
      var uibModalInstance = $uibModal.open({
        animation: $scope.animationsEnabled,
        templateUrl: "/portal/app/UI-Canal/partials/materialapoio.html",
        controller: function ($uibModalInstance, $scope) {
          $scope.cancel = function () {
            $uibModalInstance.dismiss("cancel");
          };
        },
      });
    };
  },
]);

/**
 * Controllers dos modais
 **/
appComponents.controller("ModalCtrl", [
  "$scope",
  "$uibModalInstance",
  "$timeout",
  "vrModalCustomize",
  "data",
  function ($scope, $uibModalInstance, $timeout, vrModalCustomize, data) {
    $scope.onstate = "awaiting";
    $scope.LOADING = false;

    $scope.data = data;

    $scope.doSomethingToSuccess = function () {
      $scope.LOADING = true;
      $timeout(function () {
        $scope.LOADING = false;
        $scope.onstate = "success";
      }, 1000);
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss("close");
    };

    $scope.ok = function (data) {
      $uibModalInstance.close(data);
    };

    $scope.changeState = function (state) {
      $scope.onstate = state;
    };

    vrModalCustomize.toCenter($uibModalInstance);

    if (constants.SETTINGS.DEBUG) {
      $scope.exposeScope("ModalCtrl", $scope);
    }
  },
]);

/**
 * Controller de navegação
 **/
appComponents.controller("NavigationController", [
  "$rootScope",
  "$scope",
  "$window",
  "$uibModal",
  "$attrs",
  "$timeout",
  function ($rootScope, $scope, $window, $uibModal, $attrs, $timeout) {
    $scope.substate = "";
    $scope.products = null;
    $scope.cardChecked = false;

    this.setView = function (viewName, product) {
      if (!this.isCardChecked() && viewName === "mycards") {
        $scope.substate = "confirm";
        return;
      }

      //reinicia o 'substate' para possibilitar reiniciar a view ao clicar no menu
      $scope.substate = {};
      $timeout(function () {
        $scope.substate = viewName;
      });

      //$scope.substate = viewName;
      if (product) {
        $rootScope.$broadcast(constants.EVENTS.NAVIGATION_SET_VIEW_PRODUCT, {
          product: product,
        });
      }
    };

    this.isCardChecked = function () {
      return $scope.cardChecked;
    };

    this.checkCard = function () {
      $scope.cardChecked = true;
    };

    this.setProducts = function (products) {
      $scope.products = products;
    };

    this.getProducts = function () {
      return $scope.products;
    };

    this.isView = function (viewName) {
      return $scope.substate == viewName;
    };

    this.setDefault = function (viewName) {
      if ($window.location.hash) {
        this.setView($window.location.hash.replace("#/", ""));
      } else {
        this.setView(viewName);
      }
    };

    this.setLocation = function (location, validation) {
      if (typeof validation !== "undefined") {
        if (validation() === true) {
          window.location.href = location;
        }
      } else {
        window.location.href = location;
      }
    };

    //Abrir modais
    this.open = function (modalPath, size) {
      var opts = {
        templateUrl: modalPath,
        controller: "ModalCtrl",
        backdrop: "static",
        keyboard: false,
      };

      if (size) opts.size = size;

      return $uibModal.open(opts);
    };

    this.hasURI = $rootScope.hasURI;

    // configura view 'default': procura por 'hash' na url, atributo 'vrDefaultView' ou parametro em input hidden vindo do lumis
    if (constants.SETTINGS.DEBUG) {
      console.log(
        "NavigationController: Aplicando lógica de exibição automática de painel ativo..."
      );
    }

    this.vrDefaultView = function () {
      var viewHash = $window.location.hash;
      var nav = this;
      var vrDefaultView = angular
        .element("[vr-default-view]")
        .attr("vr-default-view");
      if (viewHash && viewHash.length > 0) {
        if (constants.SETTINGS.DEBUG) {
          console.log(
            "NavigationController: Recuperado painel ativo via url: " + viewHash
          );
        }
        var view = viewHash.substring(viewHash.indexOf("/") + 1);
        if (!this.isView(view)) {
          $timeout(function () {
            nav.setView(view);
          }, 200);
        }
      } else if (vrDefaultView && vrDefaultView.length > 0) {
        if (constants.SETTINGS.DEBUG) {
          console.log(
            "NavigationController: Recuperado painel ativo via atributo vr-default-view: " +
              vrDefaultView
          );
        }
        if (!this.isView(vrDefaultView)) {
          $timeout(function () {
            nav.setView(vrDefaultView);
          }, 200);
        }
      } else {
        var element = angular
          .element(document)
          .find('input[name="lumPrevParams"]');
        if (element.length > 0) {
          var findView = function (elementValue) {
            //descobre a 'showView' a partir do elemento 'lumPrevParams' montado pelo Lumis
            var baseString = decodeURIComponent(elementValue).replace(
              /\+/g,
              " "
            );
            var xmlDoc = $.parseXML(baseString);
            var xml = $(xmlDoc);
            return xml.find("p[n=showView]").text();
          };

          var view = findView(element.val());
          if (view) {
            if (constants.SETTINGS.DEBUG) {
              console.log(
                "NavigationController: Recuperado painel ativo via atributo lumPrevParams: " +
                  view
              );
            }

            if (!this.isView(view)) {
              $timeout(function () {
                nav.setView(view);
              }, 200);
            }
          }
        }
      }
    };

    // Registro de eventos
    var navigation = this;

    $scope.$on(constants.EVENTS.NAVIGATION_CHECK_CARD, function () {
      navigation.checkCard();
    });

    $scope.$on(constants.EVENTS.NAVIGATION_SET_VIEW, function (event, data) {
      navigation.setView(data.view);
    });

    $scope.$on(
      constants.EVENTS.NAVIGATION_SET_PRODUCTS,
      function (event, data) {
        navigation.setProducts(data.products);
      }
    );

    if (constants.SETTINGS.DEBUG) {
      $scope.exposeScope("NavigationController", $scope);
    }

    this.vrDefaultView();
  },
]);

appComponents.factory("broadcastService", function ($rootScope) {
  return {
    send: send,
  };

  function send(msg, data) {
    $rootScope.$broadcast(msg, data);
  }
});
